import { configureStore, Middleware } from "@reduxjs/toolkit";
import {
  createMigrate,
  createTransform,
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
// import storageSession from "redux-persist/lib/storage/session";
import storage from "redux-persist/lib/storage";

import { thunk } from "redux-thunk";

import rootReducer from "./reducers";

import dayjs from "dayjs";
// import { gtmMiddleware } from "../utils/gtmMiddleware";

// const dateTransform = createTransform(null, (outBoundState, k) => {
//   var val = JSON.stringify(outBoundState);
//   return parseJSON(val);
// });

const dateTransform = createTransform(
  // Convert Dayjs objects to ISO strings during serialization
  (inBoundState, key) => {
    if (dayjs.isDayjs(inBoundState)) {
      return inBoundState.toISOString();
    }
    return inBoundState;
  },
  // Convert ISO strings back to Dayjs during rehydration
  (outBoundState, key) => {
    if (typeof outBoundState === "string" && dayjs(outBoundState).isValid()) {
      return dayjs(outBoundState);
    }
    return outBoundState;
  },
);

// Add versioning and migration to handle state changes
const migrations = {
  // Increment version to force a state reset (clear old cached user data)
  1: (state: any) => {
    // Clear user state to force fresh fetch after role changes
    return {
      ...state,
      user: {
        currentUser: null,
        loading: false,
        error: null,
        hasFetched: false,
      },
    };
  },
};

const persistConfig = {
  key: "ReAgentIntel_root",
  version: 1.1,
  storage: storage,
  transforms: [dateTransform],
  blacklist: ["pageFilters"], // Don't persist page-specific filters (session-only)
  migrate: createMigrate(migrations, { debug: false }),
};

const middlewares: Middleware[] = [thunk as unknown as Middleware]; //, gtmMiddleware];

if (process.env.NODE_ENV === `development`) {
  const { logger } = require(`redux-logger`);
  middlewares.push(logger);
}

type InitialRootState = ReturnType<typeof rootReducer>;
const persistedReducer = persistReducer<InitialRootState>(
  persistConfig,
  rootReducer,
);
export const store = configureStore({
  devTools: process.env.NODE_ENV === "development",
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          "userLoaded",
        ],
        ignoredPaths: ["register", "user.user"],
      },
    }).concat(...middlewares),
});

declare global {
  interface Window {
    store: typeof store;
  }
}
window.store = store;

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
